(function ($) {
    function updateBundleSummary($bundledContainer) {
        if (!$bundledContainer.length || $bundledContainer.attr('data-bundle-phase-3-summary') !== '1') {
            return;
        }

        const $count = $bundledContainer.find('.product-bundle-summary__count-value');
        const $cost = $bundledContainer.find('.product-bundle-summary__cost-value');
        const currency = ($bundledContainer.attr('data-bundle-summary-currency') || '').toString();
        let selectedCount = 0;
        let totalCost = 0;

        $bundledContainer.find('.product-bundle-card').each(function () {
            const $card = $(this);
            const $checkbox = $card.find('.product-bundle-card__checkbox');

            if (!$checkbox.is(':checked')) {
                return;
            }

            selectedCount += 1;

            const bundlePrice = parseFloat($card.attr('data-bundle-price'));
            if (!isNaN(bundlePrice)) {
                totalCost += bundlePrice;
            }
        });

        $count.text(selectedCount);
        $cost.text(currency + totalCost.toFixed(2));
    }

    function pushBundleAnalyticsEvent(eventName, payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({event: eventName}, payload));
    }

    function getMatchedBundleVariation($card) {
        const $variationContainer = $card.find('.product-bundle-card__variations');
        const encodedVariations = $variationContainer.attr('data-variations');
        const selectedAttributes = {};
        let hasMissingSelection = false;

        $card.find('.product-bundle-card__variation-select').each(function () {
            const $select = $(this);
            const attributeName = $select.attr('data-attribute_name');
            const value = ($select.val() || '').toString();

            selectedAttributes[attributeName] = value;

            if (!value) {
                hasMissingSelection = true;
            }
        });

        if (hasMissingSelection || !encodedVariations) {
            return {variationId: 0, attributes: selectedAttributes};
        }

        let variations;
        try {
            variations = JSON.parse(encodedVariations);
        } catch (error) {
            return {variationId: 0, attributes: selectedAttributes};
        }

        const matchedVariation = (variations || []).find((variation) => {
            if (!variation || !variation.attributes || variation.is_in_stock === false) {
                return false;
            }

            return Object.keys(selectedAttributes).every((attributeName) => {
                const selectedValue = selectedAttributes[attributeName];
                const variationValue = variation.attributes[attributeName];

                if (!selectedValue) {
                    return false;
                }

                if (!variationValue) {
                    return true;
                }

                return variationValue === selectedValue;
            });
        });

        if (!matchedVariation || !matchedVariation.variation_id) {
            return {variationId: 0, attributes: selectedAttributes};
        }

        return {
            variationId: parseInt(matchedVariation.variation_id, 10) || 0,
            attributes: selectedAttributes
        };
    }

    function syncBundleVariationSelection($card) {
        const selectedVariation = getMatchedBundleVariation($card);

        $card.find('.product-bundle-card__variation-id').val(selectedVariation.variationId || 0);

        if (selectedVariation.variationId) {
            $card.removeClass('product-bundle-card--variation-error');
        }

        return selectedVariation;
    }

    $(document).on('change', '.product-bundle-card__variation-select', function () {
        const $bundleCard = $(this).closest('.product-bundle-card');
        const selectedColor = ($(this).val() || '').toString();
        const bundleId = parseInt($bundleCard.find('.product-bundle-card__checkbox').attr('data-product_id'), 10) || 0;

        syncBundleVariationSelection($bundleCard);
        updateBundleSummary($bundleCard.closest('.bundled'));

        if ($bundleCard.attr('data-bundle-phase-3-analytics') === '1' && selectedColor) {
            pushBundleAnalyticsEvent('bundle_swatch_select', {
                bundle_product_id: bundleId,
                attribute: 'attribute_pa_color',
                value: selectedColor
            });
        }
    });

    $(document).on('change', '.product-bundle-card__checkbox', function () {
        updateBundleSummary($(this).closest('.bundled'));
    });

    $('.bundled').each(function () {
        updateBundleSummary($(this));
    });

    $(document).on('click', '.single_add_to_cart_button', function (e) {
        e.preventDefault();

        let $thisbutton = $(this),
            $form = $thisbutton.closest('form.cart'),
            id = $thisbutton.val(),
            product_qty = $form.find('input[name=quantity]').val() || 1,
            product_id = $form.find('input[name=product_id]').val() || id,
            variation_id = $form.find('input[name=variation_id]').val() || 0,
            product_details = $thisbutton.parents('.product-details'),
            bundles = product_details.find('.product-bundle-card');

        if($thisbutton.is('.bundle_add_to_cart_button')){
            product_id = $thisbutton.attr('value');
            variation_id = 0;
        }

        let data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
            bundles: []
        };

        // can be added or not
        if($thisbutton.is('.disabled')){
            return false;
        }

        let hasBundleVariationError = false;

        bundles.each(function (){
            const bundle = $(this),
                checkbox = bundle.find('.product-bundle-card__checkbox'),
                bundle_id = parseInt(checkbox.attr('data-product_id'), 10),
                bundleProductType = checkbox.attr('data-product_type');

            if (!bundle_id) {
                return;
            }

            if(checkbox.is(':checked')){
                if (bundleProductType === 'variable') {
                    const selectedVariation = syncBundleVariationSelection(bundle);

                    if (!selectedVariation.variationId) {
                        hasBundleVariationError = true;
                        bundle.addClass('product-bundle-card--variation-error');
                        return;
                    }

                    data.bundles.push({
                        product_id: bundle_id,
                        variation_id: selectedVariation.variationId,
                        attributes: selectedVariation.attributes
                    });
                    return;
                }

                data.bundles.push({
                    product_id: bundle_id
                });
            }
        });

        if (hasBundleVariationError) {
            return false;
        }

        if (data.bundles.length && bundles.filter('[data-bundle-phase-3-analytics="1"]').length) {
            pushBundleAnalyticsEvent('bundle_addon_adoption', {
                product_id: parseInt(product_id, 10) || 0,
                bundle_count: data.bundles.length,
                bundle_product_ids: data.bundles.map((bundle) => bundle.product_id)
            });
        }

        $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
            },
            success: function (response) {
                if (response.error && response.product_url) {
                    console.log(response);
                } else {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                }
            },
        });

        return false;
    });

})(jQuery);